import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import './Login.css';
import myImage from '../../assets/aeryum_logo_nobackground.png';
import hero from '../../assets/LoginBackground.JPG';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage(null);

    if (!token) {
      setMessage({ type: 'error', text: 'This password reset link is invalid.' });
      return;
    }
    if (password.length < 8) {
      setMessage({ type: 'error', text: 'Password must contain at least 8 characters.' });
      return;
    }
    if (password !== confirmation) {
      setMessage({ type: 'error', text: 'Passwords do not match.' });
      return;
    }

    setLoading(true);
    try {
      await axios.post('/auth/reset-password', { token, newPassword: password });
      setMessage({ type: 'success', text: 'Password updated. Redirecting to sign in...' });
      window.setTimeout(() => navigate('/login', { replace: true }), 1600);
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.response?.data?.message
          || error.response?.data?.error
          || 'This link has expired or was already used.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login">
      <div className="login__shell">
        <section className="login__left" aria-labelledby="reset-title">
          <header className="login__brand">
            <img src={myImage} alt="Aeryum" className="login__logo" />
          </header>
          <div className="login__copy">
            <h1 id="reset-title" className="login__title">Create a new password</h1>
            <p className="login__subtitle">Choose a secure password with at least 8 characters.</p>
          </div>
          <form className="login__form" onSubmit={handleSubmit}>
            <label className="login__label" htmlFor="new-password">New Password</label>
            <input
              id="new-password"
              type="password"
              autoComplete="new-password"
              className="login__input"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
            <label className="login__label" htmlFor="confirm-password">Confirm Password</label>
            <input
              id="confirm-password"
              type="password"
              autoComplete="new-password"
              className="login__input"
              value={confirmation}
              onChange={(event) => setConfirmation(event.target.value)}
              required
            />
            {message && (
              <p className={`login__message login__message--${message.type}`}>{message.text}</p>
            )}
            <button type="submit" className="login__submit" disabled={loading}>
              {loading ? <span className="login__spinner" /> : 'Update password'}
            </button>
            <Link className="login__back-link" to="/login">Back to sign in</Link>
          </form>
        </section>
        <aside className="login__right" role="img" aria-label="Industrial night city">
          <img src={hero} alt="" className="login__bg" />
        </aside>
      </div>
    </main>
  );
}
